module.exports = __webpack_public_path__ + "img/stock0.9babd267.png";